import React from "react";
import { useLang } from "@/context/LangContext";

export default function LangSwitch({ testid = "lang-switch" }) {
    const { lang, setLang } = useLang();
    return (
        <div className="inline-flex rounded-full border border-slate-200 p-0.5 text-[11px] font-semibold" data-testid={testid}>
            {["fr", "en"].map((l) => (
                <button key={l} type="button" onClick={() => setLang(l)} data-testid={`${testid}-${l}`} aria-pressed={lang === l}
                    className={`px-2.5 py-1 rounded-full uppercase transition-colors ${lang === l ? "bg-[#0b2545] text-[#fff]" : "text-[#0b2545] hover:text-[#f26b1d]"}`}>
                    {l}
                </button>
            ))}
        </div>
    );
}
